import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faTag,
  faUniversity,
  faArrowLeft,
  faUser,
  faThumbsUp,
  faThumbsDown,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import ShortIcon from "../../assets/images/Reviews/short.png";

const ShortReviewView = ({ reviewData }) => {
  // Parse data with proper fallbacks
  const parseList = (data) => {
    if (!data) return [];
    try {
      return typeof data === "string"
        ? JSON.parse(data)
        : Array.isArray(data)
        ? data
        : [];
    } catch (e) {
      return [];
    }
  };

  const pros = parseList(reviewData?.pro_detail);
  const cons = parseList(reviewData?.con_detail);
  const isAnonymous = reviewData?.go_anonymous === "1";
  const reviewTags = reviewData?.review_tags
    ? reviewData.review_tags.split(",").map((tag) => tag.trim())
    : [];

  const navigate = useNavigate();

  // Render star ratings
  const renderStars = (rating) => {
    const numericRating = Number(rating) || 0;
    return [...Array(5)].map((_, i) => (
      <FontAwesomeIcon
        key={i}
        icon={faStar}
        className={i < numericRating ? "srv-star-filled" : "srv-star-empty"}
      />
    ));
  };

  return (
    <div className="srv-container">
      {/* Page Header */}
      <div className="srv-header">
        <button className="srv-back-button" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        <div className="srtIcon">
          <img className="srt-img" src={ShortIcon} alt="short" />
          <h2 className="srv-page-title">Short Review</h2>
        </div>
      </div>

      <div className="srv-review-card">
        {/* College Header */}
        <div className="srv-college-header">
          {reviewData?.clg_logo ? (
            <img
              src={reviewData.clg_logo}
              alt={`${reviewData.clg_name || "College"} logo`}
              className="srv-college-logo"
            />
          ) : (
            <div className="srv-college-logo">
              <FontAwesomeIcon icon={faUniversity} />
            </div>
          )}
          <div>
            <h3 className="srv-card-title">
              {reviewData?.clg_name || "College"} Review
            </h3>
            {reviewData?.referral_code && (
              <p className="srv-referral-code">
                <strong>Referral Code:</strong>{" "}
                {reviewData.referral_code || "N/A"}
              </p>
            )}
          </div>
        </div>

        <div className="srv-card-content">
          {/* Reviewer Info */}
          <div className="srv-reviewer-info">
            <p>
              <strong>Reviewed by:</strong>{" "}
              {isAnonymous ? "Anonymous" : reviewData?.name || "Anonymous"}
            </p>
            {!isAnonymous && (
              <>
                <p>
                  <strong>Email:</strong> {reviewData?.email || "N/A"}
                </p>
                <p>
                  <strong>Contact:</strong> {reviewData?.phone_number || "N/A"}
                </p>
              </>
            )}
            <p>
              <strong>Year of Admission:</strong>{" "}
              {reviewData?.year_of_admission || "N/A"}
            </p>
          </div>

          {/* Rating Section */}
          <div className="srv-rating-section">
            <h4 className="srv-section-title">
              <FontAwesomeIcon icon={faStar} />
              Overall Rating
            </h4>
            <div className="srv-star-rating">
              {renderStars(reviewData?.ratings)}
              <span className="srv-rating-value">
                {reviewData?.ratings || 0}.0
              </span>
            </div>
          </div>

          {/* Review Tags */}
          {reviewTags.length > 0 && (
            <div className="srv-tags-section">
              <h4 className="srv-section-title">
                <FontAwesomeIcon icon={faTag} />
                Tags
              </h4>
              <div className="srv-tags-container">
                {reviewTags.map((tag, index) => (
                  <span key={index} className="srv-tag">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Review Content */}
          <div className="srv-review-section">
            <h4 className="srv-section-title">Review Title</h4>
            <p className="srv-review-title">
              {reviewData?.review_title || "N/A"}
            </p>
          </div>

          <div className="srv-review-section">
            <h4 className="srv-section-title">Review Details</h4>
            <p className="srv-review-detail">
              {reviewData?.review_detail || "N/A"}
            </p>
          </div>

          <div>
            <div className="br-pros-cons-grid">
              {pros.length > 0 && (
                <div className="br-pros-list">
                  <h4>
                    <FontAwesomeIcon icon={faThumbsUp} /> Pros
                  </h4>
                  {pros.length > 0 ? (
                    <ul>
                      {pros.map((item, i) => (
                        <li key={`pro-${i}`}>{item}</li>
                      ))}
                    </ul>
                  ) : (
                    <p>N/A</p>
                  )}
                </div>
              )}

              {cons.length > 0 && (
                <div className="br-cons-list">
                  <h4>
                    <FontAwesomeIcon icon={faThumbsDown} /> Cons
                  </h4>
                  {cons.length > 0 ? (
                    <ul>
                      {cons.map((item, i) => (
                        <li key={`con-${i}`}>{item}</li>
                      ))}
                    </ul>
                  ) : (
                    <p>N/A</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShortReviewView;
